<template>
    <div class="pci-cart-wrapper">
        <modal :show="showPolicies">
            <div class="pci-policies-overlay">
                <div class="pci-policies-close-bar"><span class="pci-policies-close-btn" @click="showPolicies=false">X</span></div>
                <policies :api-client="{getItemsPrms:apiClient.getPoliciesPrms}" v-if="showPolicies"></policies>
            </div>
        </modal>

        <modal-x :show="showContacts" @onclose="showContacts=false" :contentStyle="{'max-width': '600px', height: '100%'}">
            <paged-contact v-on:onselect="onContactSelected" v-if="showContacts" :skipAddress="!needAddress"></paged-contact>
        </modal-x>

        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
            <div ref="container">
                <!-- Toolbar -->
                <div class="pci-toolbar">
                    <span class="pci-toolbar-left">
                        <span class="pci-btn pci-btn-refresh" @click="loadItems">{{lang.common.refresh}}?</span>
                    </span>
                    <span class="pci-btn pci-btn-primary" @click="showContacts=true">{{lang.cart.selectContact}}</span>
                    <span class="pci-arrow glyphicon glyphicon-chevron-right"></span>
                    <span class="pci-btn pci-btn-primary" :class="{disabled:selectedContact===null}" @click="checkout">{{lang.cart.submitOrder}}</span>
                </div>
                <div v-if="alertMsg" class="pci-alert-msg">{{alertMsg}}</div>

                <!-- Selected Contact Card -->
                <div v-if="selectedContact!==null" class="pci-contact-card">
                    <div class="pci-contact-header">
                        <span class="pci-contact-title">{{selectedContact.title}}({{selectedContact.id}})</span>
                    </div>
                    <div class="pci-contact-detail">
                        <span class="pci-label">{{lang.common.name}}:</span>{{selectedContact.name}} / <span class="pci-label">{{lang.common.phone}}:</span>{{selectedContact.phone}}
                        <div>
                            <div class="pci-contact-address-label">{{lang.contact.deliveryAddress}}:</div>
                            {{selectedContact.address}}
                        </div>
                        <div v-if="selectedContact.pickContact!==null" class="pci-pickup-section">
                            <div class="pci-pickup-badge">{{lang.common.pickup}}</div>
                            <div>{{selectedContact.pickContact.title}}:{{selectedContact.pickContact.phone}}</div>
                            <div>{{selectedContact.pickContact.address}}</div>
                        </div>
                    </div>
                </div>

                <!-- Select All / Unselect All -->
                <div class="pci-selection-row">
                    <div class="pci-selection-group">
                        <span>{{lang.cart.unselectAll}}</span>
                        <img @click="selectAll(false)" :src="srcRoot+'/images/sys/tickhollo.png'" class="pci-check-icon">
                    </div>
                    <div class="pci-selection-divider"></div>
                    <div class="pci-selection-group">
                        <span>{{lang.cart.selectAll}}</span>
                        <img @click="selectAll(true)" :src="srcRoot+'/images/sys/tick.png'" class="pci-check-icon">
                    </div>
                </div>

                <!-- Shop Groups -->
                <div v-for="grp in itemGroups" :key="grp.shop.shopUserId" class="pci-shop-group" :data-shop-user-id="grp.shop.shopUserId">
                    <div class="pci-shop-header">
                        <h3 class="pci-shop-name">{{grp.shop.shopName}}</h3>
                        <span class="pci-btn-terms" @click="showPolicies=true">{{lang.cart.terms}}</span>
                    </div>
                    <div v-for="item in grp.items" :key="item.id" class="ags-carted-item">
                        <div class="pci-item-row" :item-data="item.id" ref="cartitem">

                            <!-- Image Column -->
                            <div class="pci-item-image-col">
                                <span class="pci-btn-remove" @click="removeCartItem(item)">X</span>
                                <router-link :to="'/detail?postId='+item.postId" class="pci-item-thumb-link">
                                    <img :src="item.post.thumbPath" title="missing image" class="pci-item-thumb">
                                </router-link>
                            </div>

                            <!-- Info Column -->
                            <div class="pci-item-info-col">
                                <div>
                                    <router-link :to="'/detail?postId='+item.postId" class="pci-item-title-link">{{item.title}}</router-link>
                                </div>
                                <div class="pci-item-props">
                                    <span v-for="pc in item.propCats" class="pci-item-prop">
                                        {{pc.parent.name}}:{{pc.child.name}}
                                    </span>
                                </div>
                                <div class="pci-item-price-row">
                                    <span :price-val="item.price" class="pci-item-price">${{item.price}}</span>
                                    <span class="pci-item-quant-label">X</span>
                                    <input class="pci-item-quant-input" type="text" v-model="item.quant">
                                </div>
                            </div>

                            <!-- Checkbox Column -->
                            <div class="pci-item-check-col" @click="toggleItem(item)">
                                <div class="pci-item-checkbox">
                                    <img v-if="isSelected(item)" :src="srcRoot+'/images/sys/tick.png'" class="agx-icon-checked">
                                    <img v-else :src="srcRoot+'/images/sys/tickhollo.png'" class="agx-icon-unchecked">
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </paged-loading>
    </div>
</template>
<script>
    import pagedLoading from '../components/base/PagedLoading.vue';
    import queryString from '../utl/queryString';
    import modal from './base/Modal.vue';
    import modalX from './base/ModalX1.vue';
    import policies from './Policies.vue';
    import pagedContact from './PagedContact.vue';
    import localCart from "../api/localCart.js";

    export default {
        components: {
            pagedLoading: pagedLoading,
            modal: modal,
            modalX: modalX,
            policies: policies,
            pagedContact: pagedContact
        },
        data: function () {
            return {
                paging: { page: 1, pageSize: 1, count: 1 },
                loadingImg: false,
                itemGroups: [],
                showPolicies: false,
                showContacts: false,
                selectedContact: null,
                alertMsg: null,
                selectedItems: []
            };
        },
        computed: {
            apiClient: function () {
                return this.mxnAgxApi.cartApiClient;
            },
            lang: function () {
                return this.$store.getters.lang;
            },
            srcRoot: function () {
                return this.$store.getters.configs.srcRoot;
            },
            needAddress:function(){
                return this.$store.getters.shopConfigs.needDeliveryAddress;
            }
        },
        methods: {
            isSelected: function (item) {
                return this.selectedItems.indexOf(item.id) !== -1;
            },
            toggleItem: function (item) {
                var idx = this.selectedItems.indexOf(item.id);
                if (idx !== -1) {
                    this.selectedItems = this.selectedItems.filter(function (id) { return id !== item.id; });
                } else {
                    this.selectedItems = this.selectedItems.concat([item.id]);
                }
            },
            selectAll: function (isSelect) {
                if (isSelect === true) {
                    var allIds = [];
                    for (var g = 0; g < this.itemGroups.length; g++) {
                        var grp = this.itemGroups[g];
                        for (var i = 0; i < grp.items.length; i++) {
                            allIds.push(grp.items[i].id);
                        }
                    }
                    this.selectedItems = allIds;
                } else {
                    this.selectedItems = [];
                }
                var items = this.$refs.cartitem;
                if (items && items.length > 0) {
                    for (var j = 0; j < items.length; j++) {
                        var it = items[j];
                        if (isSelect === true) {
                            it.classList.add("act-selected");
                        } else {
                            it.classList.remove("act-selected");
                        }
                    }
                }
            },
            addToAccountCartPrms: function () {
                var that = this;
                return new Promise(function (rs, rj) {
                    var arrTasks = [];
                    var items = localCart.api.getCart().items;
                    if (items !== null && items.length > 0) {
                        that.loadingImg = true;
                        for (var i = 0; i < items.length; i++) {
                            var item = items[i];
                            var task = that.apiClient.addToCartPrms(item);
                            arrTasks.push(task);
                        }
                        Promise.all(arrTasks).then(function (ret) {
                            localCart.api.clearCart();
                            rs();
                            that.loadingImg = false;
                        });
                    } else {
                        rs();
                    }
                });
            },
            onContactSelected: function (contact) {
                this.selectedContact = contact;
                this.showContacts = false;
            },
            reloadItems: function () {
                this.apiClient.pingPrms().then((ret) => {
                    if (ret.hasLogin === true) {
                        this.addToAccountCartPrms().then(() => {
                            var obj = { uid: this.userId };
                            this.loadItems(queryString().getString(obj));
                        });
                    }
                });
            },
            onPageChange: function (newPage) {
                var obj = { page: newPage };
                this.loadItems(queryString().getString(obj));
            },
            buildSelectedItemsData: function () {
                var selectedData = [];
                for (var g = 0; g < this.itemGroups.length; g++) {
                    var grp = this.itemGroups[g];
                    for (var i = 0; i < grp.items.length; i++) {
                        var item = grp.items[i];
                        if (this.selectedItems.indexOf(item.id) !== -1) {
                            // Try to read quantity from DOM input (user may have edited it)
                            var quant = item.quant;
                            var cartItemEls = this.$refs.cartitem;
                            if (cartItemEls) {
                                for (var j = 0; j < cartItemEls.length; j++) {
                                    if (cartItemEls[j].getAttribute("item-data") == item.id) {
                                        var input = cartItemEls[j].querySelector(".pci-item-quant-input");
                                        if (input && input.value) quant = input.value;
                                        break;
                                    }
                                }
                            }

                            // Build props description string from propCats
                            var propsDescr = "";
                            if (item.propCats && item.propCats.length > 0) {
                                var parts = [];
                                for (var p = 0; p < item.propCats.length; p++) {
                                    parts.push(item.propCats[p].parent.name + ":" + item.propCats[p].child.name);
                                }
                                propsDescr = parts.join(", ");
                            }

                            selectedData.push({
                                cartItemId: item.id,
                                quant: quant,
                                price: item.price,
                                propsDescr: propsDescr,
                                thumbSrc: item.post ? item.post.thumbPath : "",
                                title: item.title,
                                shopUserId: grp.shop.shopUserId,
                                shopName: grp.shop.shopName
                            });
                        }
                    }
                }
                return selectedData;
            },
            checkout: function () {
                if (this.selectedContact === null) {
                    this.alertMsg = this.lang.cart.selectAddress;
                    return;
                }
                this.alertMsg = null;
                var selectedItems = this.buildSelectedItemsData();
                var otherData = { contact: this.selectedContact, selectedItems: selectedItems };
                this.apiClient.checkout((onSubmitData) => {
                    this.$router.push({ name: "orders" });
                },
                    otherData);
            },
            loadItems: function (query) {
                this.itemGroups = [];
                this.loadingImg = true;
                this.apiClient.setOnRemove((ret) => {
                    var itemIds = ret.itemIds;
                    if (ret.ok === true) {
                        for (var i = 0; i < itemIds.length; i++) {
                            var id = itemIds[i];
                            this.itemGroups.forEach((g) => {
                                g.items = g.items.filter((it) => { return it.id != id; });
                            });
                        }
                    }
                });
                this.apiClient.getCartItemsPrms(query).done((ret) => {
                    this.loadingImg = false;
                    var filter = ret.filter;
                    this.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    this.itemGroups = ret.items;

                    this.$nextTick(() => {
                        this.apiClient.registerItem(this.$refs.container, this.reloadItems);
                    });

                }).fail((ret) => {
                    this.loadingImg = false;
                });
            }
        },
        created: function () {
            this.apiClient.onLoginApi.on(this.reloadItems);
            this.reloadItems();
        },
        destroyed: function () {
            this.apiClient.onLoginApi.remove(this.reloadItems);
        },
        mounted: function () {

        }
    }
</script>